import _ from 'underscore';
import ko from 'knockout';
import { CampaignType } from '@bingads-webui-campaign/campaign-ui-common';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/bulk-campaign-exclusions');

const whitelistCampaignTypesForDefaultSelections = [
  CampaignType.None,
  CampaignType.Default,
  CampaignType.Shopping,
  CampaignType.DynamicSearchAds,
  CampaignType.Audience,
  CampaignType.Smart,
  CampaignType.Hotel,
  CampaignType.All,
];

const defaultSelections = [
  {
    value: '3',
    text: i18n.get('BulkEdit_SiteExclusions_Label'),
    label: i18n.get('BulkEdit_SiteExclusions_Label'),
    confirmText: i18n.get('BulkEdit_Campaigns_UpdateSiteExclusionConfirmMsg'),
    helpTopic: 'Page_CampaignExclusionSettingsPopup_WebsitesToExclude',
    name: 'SiteExclusions',
    helpAriaLabel: (i18n.get('Click to learn more about {{item}}') || '').replace('{{item}}', i18n.get('BulkEdit_SiteExclusions_Label')),
  }, {
    value: '5',
    text: i18n.get('BulkEdit_IPExclusions_Label'),
    label: i18n.get('BulkEdit_IPExclusions_Label'),
    confirmText: i18n.get('BulkEdit_Campaigns_UpdateIPExclusionConfirmMsg'),
    helpTopic: 'Page_CampaignExclusionSettingsPopup_IPAddressToExclude',
    name: 'IPExclusions',
    helpAriaLabel: (i18n.get('Click to learn more about {{item}}') || '').replace('{{item}}', i18n.get('BulkEdit_IPExclusions_Label')),
  },
];

const endDateSelection = {
  value: '7',
  text: i18n.get('Audience_Campaign_BulkEdit_EndDate'),
  label: i18n.get('Audience_Campaign_BulkEdit_EndDate'),
  confirmText: i18n.get('Audience_Campaign__BulkEndDate_ConfirmMsg'),
  name: 'EndDate',
  shouldGridReload: true,
};

const adScheduleTimeZoneSelection =  {
  value: '6',
  text: i18n.get('BulkEdit_AdScheduleTimeZone_OptionText'),
  label: i18n.get('BulkEdit_AdScheduleTimeZone_Label'),
  confirmText: i18n.get('BulkEdit_Campaigns_UpdateAdScheduleTimeZoneConfirmMsg'),
  helpTopic: 'pop_BA_Targeting_TimeZone',
  name: 'AdScheduleUseSearcherTimeZone',
  helpAriaLabel: (i18n.get('Click to learn more about {{item}}') || '').replace('{{item}}', i18n.get('BulkEdit_AdScheduleTimeZone_Label')),
};

export default class ViewModel {
  constructor(options = {}) {
    this.options = options;
    this.isForVNext = options.isForVNext;
    const selections = _.map(_.includes(whitelistCampaignTypesForDefaultSelections, options.campaignType) ? defaultSelections : [], (defaultSelection) => {
      return _.defaults({
        textAreaValue: ko.observable(''),
      }, defaultSelection);
    });

    if (options.campaignLifetimeBudget) {
      selections.push(endDateSelection);
    }

    if (!_.find(selections, (o) => o.name === 'AdScheduleUseSearcherTimeZone')) {
      selections.push(adScheduleTimeZoneSelection);
    }

    this.selectedValue = ko.observable([selections[0].value]);
    this.selections = selections;
    this.learnMoreText = i18n.get('Control_PaneHelp_LearnMore');
    this.title = i18n.get('Page_CampSummary_BulkToolTitleText');
    this.selectLabel = i18n.get('BulkEdit_Campaigns_BulkEditTitle');
    this.applyForThisPageOnlyInfo = i18n.get('BulkEdit_OtherChanges_ApplyForThisPageOnlyInfo');
    this.applyButtonText = i18n.get('BulkEdit_ApplyButton');
    this.cancelButtonText = i18n.get('BulkEdit_CancelButton');
    this.errorMsg = ko.observable('');
  }

  getSelection() {
    const result = _.find(this.selections, (selection) => {
      return selection.value === this.selectedValue()[0];
    });

    if (!result) {
      throw new Error('Unknown selected value for campaign bulk exclusions.');
    }

    return result;
  }

  getResult(datePicker) {
    const result = {};
    const selection = this.getSelection();

    result.SelectedBulkEditOption = selection.value;
    if (selection.name === 'EndDate') {
      const endDateMachine = datePicker.getSelectedDate();
      let endDateUTC = null;

      if (!datePicker.getState().isNodateSelected) {
        endDateUTC = i18n.realI18n.parseDate(i18n.realI18n.formatDate(endDateMachine, {
          timeZone: null,
        }), { timeZone: 'UTC' });
      }

      result[selection.name] = endDateUTC === null ? '' : i18n.realI18n.formatDate(endDateUTC, {
        timeZone: 'UTC',
        culture: this.options.scope && this.options.scope.culture,
      });
      result.HasEndDate = result[selection.name] === '' ? 'False' : 'True';
    } else {
      result[selection.name] = selection.textAreaValue();
    }

    return result;
  }

  getConfirmText() {
    return this.getSelection().confirmText;
  }

  validate(endDatePicker) {
    const selection = this.getSelection();
    let isValid = true;

    if (selection.name === 'EndDate') {
      const endDate = endDatePicker.getSelectedDate();

      isValid = !!endDate || endDatePicker.getState().isNodateSelected;
    }

    if (!isValid) {
      this.errorMsg(i18n.get('Validation_EndDateRequired'));
    }

    return isValid;
  }
}
